module.exports = __webpack_public_path__ + "img/scene-aquaculture.a8b96d29.jpg";